export const certificationsData = [
  {
    id: "capgemini-fellowship",
    title: "Exceller Edge Fellowship — Cloud & DevOps",
    issuer: "Capgemini (Early Careers Program - India)",
    date: "May 2026",
    link: "https://drive.google.com/file/d/1XM06y-NZtoVujy1aFMED_0o6rcXStOKA/view",
    description: "Hands-on fellowship covering AWS, Azure, Docker, Kubernetes, Jenkins, Terraform, Ansible, GitOps, Prometheus, Grafana, Maven, and Linux administration.",
    skills: ["Cloud Architecture", "Docker & K8s", "CI/CD & Jenkins", "Terraform IaC", "SRE Observability"],
    badgeColor: "from-blue-600 to-cyan-500",
    certId: "CEEFP2026-7060737"
  },
  {
    id: "hackviser-cybersecurity",
    title: "CORE (Certified Cybersecurity Foundations)",
    issuer: "Hackviser",
    date: "Expected Aug 2026",
    link: "https://www.linkedin.com/company/hackviserr/",
    description: "Cybersecurity training program covering Cyber Kill Chain, Incident Response, Network & Web Fundamentals, OWASP Top 10 (2025), OSINT, LLM Security, Social Engineering, and the Attacker/Defender mindset.",
    skills: ["OWASP Top 10", "Incident Response", "LLM Security", "OSINT"],
    badgeColor: "from-green-600 to-emerald-500",
    status: "Incoming"
  },
  {
    id: "code-with-harry-data-science",
    title: "The Ultimate Job Ready Data Science Course",
    issuer: "CodeWithHarry",
    date: "September 2025",
    link: "https://drive.google.com/file/d/1Ovqfa-eAOpff-3RteujPPYiroYozRTlH/view?usp=sharing",
    description: "Data Science training course authorized by CodeWithHarry focusing on Python, Pandas, NumPy, Scikit-learn, and Machine Learning.",
    skills: ["Data Science", "Python", "Pandas", "Scikit-Learn"],
    badgeColor: "from-indigo-600 to-purple-500",
    certId: "CWH-THE-ULTIMATE-JOB-READY-DATA-SCIENCE-COURSE-X1YAEVJB"
  },
  {
    id: "cisco-cybersecurity",
    title: "Introduction to Cybersecurity",
    issuer: "Cisco Networking Academy",
    date: "Certified",
    link: "https://drive.google.com/file/d/1P4ahJ8qOjWUO_C6SufR5HELJFiTJiroP/view?usp=sharing",
    description: "Core principles of information security, cyber threat landscape, cryptography, network defense, and risk management.",
    skills: ["Cybersecurity", "Network Defense", "Threat Mitigation", "Security Protocols"],
    badgeColor: "from-blue-500 to-cyan-500"
  },
  {
    id: "canonical-ubuntu",
    title: "Ubuntu Linux Professional Certificate",
    issuer: "LinkedIn Learning & Canonical",
    date: "Certified",
    link: "https://drive.google.com/file/d/1K9wQX2DzEL67qXTzff0iS6U9NS_IrWu7/view?usp=sharing",
    description: "Enterprise Linux administration, Shell scripting, Package management (APT/Snap), Process monitoring, and System security.",
    skills: ["Ubuntu Linux", "Bash Scripting", "System Administration", "Server Config"],
    badgeColor: "from-orange-500 to-amber-500"
  },
  {
    id: "anaconda-python",
    title: "Anaconda Python for Data Science Professional Certificate",
    issuer: "Anaconda",
    date: "Certified",
    link: "https://drive.google.com/file/d/1SSqWXoiOY5QgIkhW2bAJRLPT7Ge8wwcu/view?usp=sharing",
    description: "Data exploration, computational modeling, scientific computing, and statistical analysis with Python ecosystem libraries.",
    skills: ["Python", "Pandas & NumPy", "Data Analytics", "Scikit-learn"],
    badgeColor: "from-emerald-500 to-teal-500"
  }
];
